import _ from 'lodash'
import 'whatwg-fetch'
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import apiURL from './api'
import ipaddr from 'ipaddr.js'
import { RateLimiter } from "limiter"

import { Table, Col, FormGroup, FormControl, Button, Panel, HelpBlock } from "react-bootstrap";
  
const whitelists = {
  "hostkarma.junkemailfilter.com": {"resolvesTo": "127.0.0.1"},
  "list.dnswl.org": null,
  "wl.mailspike.net": null,
}

const blacklists = {
  "0spam-killlist.fusionzero.com": null,
  "0spam.fusionzero.com": null,
  "aspews.ext.sorbs.net": null,
  "b.barracudacentral.org": null,
  "bad.psky.me": null,
  "bl.blacklist.de": null,
  "bl.konstant.no": null,
  "bl.mailspike.net": null,
  "bl.nosolicitado.org": null,
  "bl.nszones.com": null,
  "bl.score.senderscore.com": null,
  "bl.spamcop.net": null,
  "bl.spameatingmonkey.net": null,
  "blacklist.woody.ch": null,
  "bsb.spamlookup.net": null,
  "cbl.abuseat.org": null,
  "cidr.bl.mcafee.com": null,
  "combined.abuse.ch": null,
  "db.wpbl.info": null,
  "dnsbl-1.uceprotect.net": null,
  "dnsbl-2.uceprotect.net": null,
  "dnsbl-3.uceprotect.net": null,
  "dnsbl.cobion.com": null,
  "dnsbl.dronebl.org": null,
  "dnsbl.inps.de": null,
  "dnsbl.justspam.org": null,
  "dnsbl.sorbs.net": null,
  "dnsrbl.org": null,
  "ipbl.zeustracker.abuse.ch": null,
  "ips.backscatterer.org": null,
  "ix.dnsbl.manitu.net": null,
  "multi.surbl.org": null,
  "pbl.spamhaus.org": null,
  "rbl.blockedservers.com": null,
  "sbl.spamhaus.org": null,
  "smtp.dnsbl.sorbs.net": null,
  "spam.abuse.ch": null,
  "spam.dnsbl.sorbs.net": null,
  "spam.rbl.blockedservers.com": null,
  "spam.rbl.msrbl.net": null,
  "spam.spamrats.com": null,
  "ubl.unsubscore.com": null,
  "virbl.dnsbl.bit.nl": null,
  "virus.rbl.msrbl.net": null,
  "xbl.spamhaus.org": null,
  "zombie.dnsbl.sorbs.net": null,
}

var limiter = new RateLimiter(4, "second");

const lookup = function (bl, ip, record) {

  return new Promise(function(resolve, reject) {

    let hostname = "";
    let ipAddr = ipaddr.parse(ip);
    let kind = ipAddr.kind();

    switch (kind) {

    case "ipv4":
      hostname = `${ipAddr.octets.reverse().join(".")}.${bl}`;
      break;
    
    default:
      reject(new Error(`works only with ipv4 for now (${kind} is not supported)`));
      
    }

    let url = new URL(apiURL);

    url.searchParams.append("name", hostname);
    url.searchParams.append("type", record);

    limiter.removeTokens(1, function() {

      fetch(url).then((res) => res.json()).then(function(data) {

        if (data.Status === 3) {
          resolve([]);  // Empty NXDOMAIN answer => not listed
        }
        
        let answer =  "Answer" in data ? data.Answer : [];

        if (data.Status === 5) {
          return reject(new Error("Temporarily unavailable"));
        }

        if (data.Status !== 0) {
          return reject(new Error(`Error fetching DNS data for "${hostname}" (error code: ${data.Status})`));
        }

        return resolve(answer);

      });

    });

  });

}

class RBLForm extends Component {

  constructor(props) {
    super(props);

    this.updateIPAddress = this.updateIPAddress.bind(this);
    this.updateData = this.updateData.bind(this);

    this.state = {
      "ipaddress": this.props.ipaddress,
    }

  }

  updateIPAddress(event) {
    this.setState({
      ipaddress: event.target.value,
    });
  }

  updateData(event) {
    event.preventDefault();
    this.props.onSubmit(this.state.ipaddress);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      ipaddress: nextProps.ipaddress,
    })
  }

  render() {
    return (
      <Panel>
        <Panel.Heading>RBL Lookup</Panel.Heading>
        <Panel.Body>
        <form onSubmit={this.updateData}>
            <FormGroup>
              <Col sm={11}>
                <FormControl type="text" value={this.state.ipaddress} onChange={this.updateIPAddress} />
                <HelpBlock>Test if your an IP address is listed in various RBLs.</HelpBlock>
              </Col>
              <Col sm={1}>
                <Button type="submit" bsStyle="primary">Lookup</Button>
              </Col>
            </FormGroup>
          </form>
        </Panel.Body>
      </Panel>
    );
  }
}

class ResultRow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      result: null,
      notes: null,
      rowClass: "",
    }

  }

  componentDidMount() {
    this.props.result.then(
      (res) => {
        this.setState({
          result: res.status,
          notes: res.notes,
          rowClass: res.rowClass,
        });
      }
    );
  }

}

class BlacklistResultRow extends ResultRow {

  render() {
  
    return (
      <tr className={this.state.rowClass}>
        <td className="text-center">{this.state.result ? this.state.result : <small className="text-muted">(pending)</small>}</td>
        <td><tt>{this.props.name}</tt></td>
        <td>{this.state.notes}</td>
      </tr>
    );

  }

}

class WhitelistResultRow extends ResultRow {

  render() {
  
    return (
      <tr className={this.state.rowClass}>
        <td className="text-center">{this.state.result ? this.state.result : <small className="text-muted">(pending)</small>}</td>
        <td><tt>{this.props.name}</tt></td>
        <td>{this.state.notes}</td>
      </tr>
    );

  }

}

class RBLResult extends Component {
   
  render() {

    // No data

    if (this.props.data == null) {
      return null;
    }

    return (
      <div>
        <Panel>
        <Panel.Heading>Blacklist report for <strong>{this.props.data.ipaddress}</strong></Panel.Heading>
          <Panel.Body>
            <Table striped bordered condensed hover>
              <thead>
                <tr>
                  <th style={{width: "80px"}} className="text-center">Result</th>
                  <th style={{width: "350px"}}>Blacklist</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                {_.keys(this.props.data.blacklists).map((bl) => <BlacklistResultRow key={`${bl}-${this.props.data.ipaddress}`} name={bl} result={this.props.data.blacklists[bl]} />)}
              </tbody>
            </Table>
          </Panel.Body>
        </Panel>
        <Panel>
          <Panel.Heading>Whitelist report for <strong>{this.props.data.ipaddress}</strong></Panel.Heading>
          <Panel.Body>
            <Table striped bordered condensed hover>
              <thead>
                <tr>
                  <th style={{width: "80px"}} className="text-center">Result</th>
                  <th style={{width: "350px"}}>Whitelist</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                {_.keys(this.props.data.whitelists).map((bl) => <WhitelistResultRow key={bl} name={bl} result={this.props.data.whitelists[bl]} />)}
              </tbody>
            </Table>
          </Panel.Body>
        </Panel>
      </div>
    );

  }
}

const lookupHelper = function(host, opts, ip, notlisted, listed) {
  
  return lookup(host, ip, "A").then(function(answers) {

    return new Promise(function(resolve, reject) {

      if (opts && opts.resolvesTo) {

        // Filter A records

        answers = answers.filter(
          (a) => a.data === opts.resolvesTo
        );

      }

      if (answers.length === 0) {
        return resolve(notlisted());
      } 

      // Attempt to lookup TXT record for details

      lookup(host, ip, "TXT").then(function(answers) {

        let notes = "No further details";
            
        if (answers.length > 0) {
          notes = answers[0].data.slice(1, -1);
        }
          
        return resolve(listed(notes));
          
      }).catch(reject);
      
    });
    
  }).catch(function(error) {
    
    return Promise.resolve({
      status: <strong className="text-warning">FAILED</strong>,
      notes: <span className="text-warning">{error.toString()}</span>,
      rowClass: "warning",
    });
    
  });
  
}


class BaseRBLTool extends Component {
  
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateData = this.updateData.bind(this);

    this.lookupBlacklist = this.lookupBlacklist.bind(this);
    this.lookupWhitelist = this.lookupWhitelist.bind(this);

    this.state = {
      ipaddress: "ipaddress" in props.match.params ? props.match.params.ipaddress : "5.79.99.201",
      data: null,
    };
   
  }

  lookupBlacklist(bl) {

    return lookupHelper(
      bl, 
      blacklists[bl], 
      this.state.ipaddress, 
      () => ({
        status: <strong className="text-success">OK</strong>,
        notes: <span className="text-muted">Not listed</span>,
        rowClass: "success",
      }),
      (notes) => ({
        status: <strong className="text-danger">LISTED</strong>,
        notes: <span className="text-danger">{notes}</span>,
        rowClass: "danger",
      })
    );

  }

  lookupWhitelist(wl) {

    return lookupHelper(
      wl, 
      whitelists[wl], 
      this.state.ipaddress, 
      () => ({
        status: <strong>Not listed</strong>,
        notes: <span className="text-muted">Not listed</span>,
        rowClass: "",
      }),
      (notes) => ({
        status: <strong className="text-success">LISTED</strong>,
        notes: <span className="text-success">{notes}</span>,
        rowClass: "success",
      })
    );

  }

  componentDidMount() {
    this.updateData();
  }

  componentDidUpdate() {

    let requestedIpaddress = _.get(this, "props.match.params.ipaddress", "5.79.99.201");

    if (requestedIpaddress === this.state.ipaddress) {
      return
    }

    // Reset state, this is a page change

    this.setState({
      ipaddress: requestedIpaddress,
      data: null,
    }, this.updateData)

  }

  handleSubmit(ipaddress) {

    const ipAddressChanged = _.get(this, "props.match.params.ipaddress", "") !== ipaddress;

    if (ipAddressChanged) {
      this.props.history.push(`/rbl/${ipaddress}`);
    }

    this.setState({
      ipaddress: ipaddress,
    }, this.updateData);

  }

  updateData() {

    let data = {
      "ipaddress": this.state.ipaddress,
      "blacklists": _.keys(blacklists).reduce((o, key) => Object.assign(o, {[key]: this.lookupBlacklist(key)}), {}),
      "whitelists": _.keys(whitelists).reduce((o, key) => Object.assign(o, {[key]: this.lookupWhitelist(key)}), {}),
    }

    this.setState({"data": data});

  }

  render() {
    return (
      <div>
        <RBLForm ipaddress={this.state.ipaddress} onSubmit={this.handleSubmit} />
        <RBLResult data={this.state.data} />
      </div>
    );
  }

}

const RBLTool = withRouter(BaseRBLTool);

export default RBLTool;



// WEBPACK FOOTER //
// ./src/RBL.js